module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iPbrjJ/images/cover.jpg?1703937625904",
      "alt": "This image is the cover for the book North Eastern Electric Stock, 1904–2020, Locomotive Portfolios"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("North Eastern Electric Stock, 1904–2020, Locomotive Portfolios\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The north east of England was the cradle of Britain's railways in the 19th Century. It was here George and Robert Stephenson would shape the steam locomotive. Then in the early 20th Century a second transport revolution took place around Newcastle when the suburban lines from the city to the coast were electrified in response to competition from the electric trams. What was created became the blueprint for modern day commuting. This book tells the story behind the creation of that network, the trains that served it. The narrative goes through the success and expansion years and ultimately the troubles that led to its demise. Our story comes full circle with the creation of the Tyne & Wear Metro, a ground breaking transport system that, like the electrified lines nearly 80 years earlier, set a new standard for suburban rail that would be the inspiration for schemes in many other parts of the country.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Graeme Gleaves\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Transport\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0